import React from "react";
import PropTypes from "prop-types";

// styles
import { CopyAttributionWidgetStyled } from "./styles";

// components
import TextToCopy from "./TextToCopy";
import CopyControl from "./CopyControl";

const CopyAttributionWidget = ({ isDesktop = false }) => {
    return (
        <CopyAttributionWidgetStyled
            flexWrap="nowrap"
            justifyContent="space-between"
        >
            <TextToCopy isDesktop={isDesktop} />
            <CopyControl isDesktop={isDesktop} />
        </CopyAttributionWidgetStyled>
    );
};

export default CopyAttributionWidget;

// prop-types
CopyAttributionWidget.propTypes = {
    isDesktop: PropTypes.bool
};
